import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Solucion() {
  const pilares = [{
    num: '01',
    title: 'Identificación de detonantes',
    desc: 'Descubrís exactamente qué alimentos y hábitos activan tu reflujo. No una lista genérica.'
  }, {
    num: '02',
    title: 'Calmar el sistema',
    desc: 'Ajustes concretos que reducen la irritación del estómago y el esófago en los primeros días.'
  }, {
    num: '03',
    title: 'Rutina digestiva correcta',
    desc: 'Horarios, forma de cenar y hábitos nocturnos que hacen que el reflujo deje de volver.'
  }];
  return <section id="solucion" className="bg-verde-oscuro py-[100px] relative" data-id="element-234">
      <div className="absolute bottom-[-1px] left-0 right-0 h-[80px] bg-crema" style={{
      clipPath: 'ellipse(55% 100% at 50% 100%)'
    }} data-id="element-235" />

      <div className="container-custom relative z-10" data-id="element-236">
        <SectionHeader eyebrow="La solución" title={<>
              Presentamos el
              <br data-id="element-238" />
              método que cambia el enfoque
            </>} description="No se trata de eliminar alimentos al azar. Ni de tomar otro suplemento. Se trata de entender tu sistema digestivo y ordenarlo en 72 horas." theme="dark" data-id="element-237" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dorado/10 border border-dorado/30 rounded-[12px] p-10 md:p-12 my-12 text-center max-w-[700px] mx-auto" data-id="element-239">
          <p className="font-display text-[clamp(20px,3.5vw,28px)] font-black text-dorado-claro leading-[1.4] mb-6" data-id="element-240">
            Sé que ya probaste todo.
            <br data-id="element-241" />
            <span className="text-white" data-id="element-242">Por eso esto es diferente.</span>
          </p>

          <p className="text-[17px] text-white/85 leading-[1.8] mb-6 max-w-[580px] mx-auto" data-id="element-243">
            No es una dieta. No es una pastilla.
            <br data-id="element-244" />
            <strong className="text-dorado-claro" data-id="element-245">
              Es un protocolo de 3 fases que aborda las causas reales del
              reflujo.
            </strong>
          </p>

          <p className="text-[17px] text-white/85 leading-[1.8] mb-6 max-w-[580px] mx-auto" data-id="element-246">
            En 72 horas, el{' '}
            <strong className="text-dorado-claro font-display text-[22px]" data-id="element-247">
              87%
            </strong>{' '}
            de las personas durmieron toda la noche por primera vez en años.{' '}
            <span className="text-white font-medium" data-id="element-248">
              Sin omeprazol. Sin dietas imposibles.
            </span>
          </p>

          <div className="w-[60px] h-[2px] bg-dorado/40 mx-auto mb-6" data-id="element-249" />

          <p className="text-[16px] text-white/70 leading-[1.7] max-w-[520px] mx-auto italic" data-id="element-250">
            Y si en 72 horas no ves diferencia,{' '}
            <strong className="text-dorado-claro not-italic" data-id="element-251">
              te devuelvo cada centavo. Sin preguntas.
            </strong>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12 mb-10" data-id="element-252">
          {pilares.map((pilar, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2,
          duration: 0.6,
          type: 'spring',
          stiffness: 100
        }} className="text-center p-8 bg-white/5 rounded-[8px] border border-white/10 hover:bg-white/10 hover:border-dorado/30 hover:shadow-[0_0_40px_rgba(201,162,39,0.1)] transition-all duration-500" data-id="element-253">
              <motion.div initial={{
            scale: 0.5,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 0.5
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.2 + 0.3,
            duration: 0.5,
            type: 'spring'
          }} className="font-display text-[48px] font-black text-dorado leading-none mb-3" data-id="element-254">
                {pilar.num}
              </motion.div>
              <div className="text-[16px] font-semibold text-blanco mb-2.5" data-id="element-255">
                {pilar.title}
              </div>
              <div className="text-[14px] text-white/70 leading-[1.6]" data-id="element-256">
                {pilar.desc}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}